import React, { useEffect, useMemo } from 'react';
import { Dropdown } from 'rsuite';
import { RSuiteDropdownStyler } from '../styles';
import { License } from '../types';

interface Props {
  paymentsData: License[];
  selected: number | undefined;
  onSelect: React.Dispatch<React.SetStateAction<number | undefined>>;
  disabled: boolean;
}

export function LicenseDropdown(props: Props): React.ReactElement {
  const { paymentsData, selected, onSelect, disabled } = props;

  const permitIdentifier = useMemo(() => {
    const permitMatchingSelectedId = paymentsData.find(
      ({ certificateInfo }) => certificateInfo.licenseId === selected
    );

    const permitDetails = permitMatchingSelectedId?.certificateInfo;
    return permitDetails?.licenseNumber ?? permitDetails?.applicationNumber;
  }, [paymentsData, selected]);

  useEffect(() => {
    if (paymentsData.length === 1) {
      const solePayment = paymentsData[0];
      const solePaymentLicenseId = solePayment.certificateInfo.licenseId;
      return onSelect(solePaymentLicenseId);
    }
  }, [paymentsData, onSelect]);

  return (
    <RSuiteDropdownStyler>
      <Dropdown
        data-testid="property-tax-reporting-permit-dropdown"
        title={permitIdentifier ?? 'Select a permit'}
        onSelect={onSelect}
        disabled={disabled || paymentsData.length === 1}
      >
        {paymentsData.map(({ certificateInfo }) => (
          <Dropdown.Item
            key={certificateInfo.licenseId}
            eventKey={certificateInfo.licenseId}
          >
            <p>
              {certificateInfo.licenseNumber ??
                certificateInfo.applicationNumber}
            </p>
          </Dropdown.Item>
        ))}
      </Dropdown>
    </RSuiteDropdownStyler>
  );
}
